import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import arrowLeft from '../../theme/assets/svg/lp_afi_arrow_left.svg';
import arrowRight from '../../theme/assets/svg/lp_afi_arrow_right.svg';
import {useNavigate} from "react-router-dom";

const AfiS5 = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Как стартовать с')}<br/><span>OMT Launchpad</span></div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapStep}`}>{t('Шаг')} 1</div>
                            <div className={`${Styles.contentBoxItemTextWrapPos}`}>
                                <div className={`${Styles.contentBoxItemTextWrapPosTitle}`}>{t('Подача заявки')}</div>
                                <div className={`${Styles.contentBoxItemTextWrapPosNote}`}>{t('Подайте заявку на проект для первичной проверки.')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemArrowWrap}`}>
                            <img src={arrowRight} alt="arrow right"/>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemArrowWrap}`}>
                            <img src={arrowLeft} alt="arrow left"/>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapStep}`}>{t('Шаг')} 2</div>
                            <div className={`${Styles.contentBoxItemTextWrapPos}`}>
                                <div className={`${Styles.contentBoxItemTextWrapPosTitle}`}>{t('Оценка')}</div>
                                <div className={`${Styles.contentBoxItemTextWrapPosNote}`}>{t('Мы оцениваем вашу команду, видение, токеномику и готовность к запуску.')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapStep}`}>{t('Шаг')} 3</div>
                            <div className={`${Styles.contentBoxItemTextWrapPos}`}>
                                <div className={`${Styles.contentBoxItemTextWrapPosTitle}`}>{t('Подготовка')}</div>
                                <div className={`${Styles.contentBoxItemTextWrapPosNote}`}>{t('Если проект одобрен, мы вместе выстраиваем механику запуска и сроки.')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemArrowWrap}`}>
                            <img src={arrowRight} alt="arrow right"/>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemArrowWrap}`}>
                            <img src={arrowLeft} alt="arrow left"/>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapStep}`}>{t('Шаг')} 4</div>
                            <div className={`${Styles.contentBoxItemTextWrapPos}`}>
                                <div className={`${Styles.contentBoxItemTextWrapPosTitle}`}>{t('Запуск')}</div>
                                <div className={`${Styles.contentBoxItemTextWrapPosNote}`}>{t('Ваш проект выходит на платформу на чётких и прозрачных условиях.')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapStep}`}>{t('Шаг')} 5</div>
                            <div className={`${Styles.contentBoxItemTextWrapPos}`}>
                                <div className={`${Styles.contentBoxItemTextWrapPosTitle}`}>{t('Рост')}</div>
                                <div className={`${Styles.contentBoxItemTextWrapPosNote}`}>{t('Мы остаёмся вовлечёнными после запуска, фокусируясь на долгосрочном развитии.')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemArrowWrap}`}>
                            <img src={arrowRight} alt="arrow right"/>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.applyBtn}`} onClick={() => navigate('/apply-form')}>{t('Подать заявку')}</div>
            </div>
        </section>
    );
};

export default AfiS5;




